import { elIds, uiClasses } from './ui-constants';

export default function injectKlarnaCss(): void {
  if (document.getElementById(elIds.stylesheet_id) !== null) {
    return;
  }
  const spinnerStyleEl = document.createElement('style');
  spinnerStyleEl.id = elIds.stylesheet_id;
  const cssText = document.createTextNode(`
    #${elIds.klarna_radio_container} {
      width: 100%;
      max-width: 600px;
      min-width: 280px;
      border: 1px solid #bfbfbf;
      border-radius: 4px;
      color: #000;
      background-color: #fff;
    }

    .${uiClasses.category_container} {
      border-bottom: 1px solid #bfbfbf;
    }

    .${uiClasses.category_container}:last-of-type {
      border-bottom: 0;
    }

    .${uiClasses.radio_container} {
      display: block;
      width: 100%;
      position: relative;
      text-align: left;
    }

    .${uiClasses.radio_label} {
      display: inline-block;
      line-height: 20px;
    }

    .${uiClasses.pm_container} {
      border-top: 1px solid #bfbfbf;
      transition: all .2s ease-in-out;
      opacity: 1;
      padding: 0.5em;
    }

    .${uiClasses.pm_container}.hidden {
      border-top: 0;
      overflow: hidden;
      height: 0;
      opacity: 0;
      padding: 0;
    }

    .${uiClasses.klarna_continue_button} {
      background-color: #000000;
      width: 100%;
      max-width: 600px;
      min-width: 280px;
      border-radius: 0;
    }

    .${uiClasses.klarna_continue_button}:hover {
      background-color: #222222;
    }
  `);
  spinnerStyleEl.appendChild(cssText);
  document.head.appendChild(spinnerStyleEl);
}
